import { IdCardApplyForm } from '../../components/id-card-apply-form/id-card-apply-form';

export const IdCardApplyPage = () => <IdCardApplyForm />;
